import React from 'react';
import { Button, Typography } from 'antd';
import { DashboardPageShell, DashboardPanel } from '../components/dashboard';
import AppLayout from '../layout/AppLayout';
import CustomerDashboardHeader from './CustomerDashboardHeader';
import CustomerPaymentBanner from './CustomerPaymentBanner';
import FleetStatusFilterGrid from './FleetStatusFilterGrid';
import FleetStatusPanel from './FleetStatusPanel';
import ForkliftDesktopTable from './ForkliftDesktopTable';
import ForkliftListControls from './ForkliftListControls';
import ForkliftMobileCardList from './ForkliftMobileCardList';
import './customerDashboardPreview.css';

const { Text, Title } = Typography;

export default function CustomerDashboardPreviewPage({
  accountLabel,
  accountMenuOpen,
  accountTriggerLabel,
  alertConfig,
  clearFilters,
  dueSoonWindow,
  loading,
  maintFilter,
  maintSummary,
  mobileHealthStatusFilters,
  mobileMaintenanceStatusFilters,
  navigate,
  search,
  selectedRowId,
  serviceFilter,
  serviceSummary,
  setAccountMenuOpen,
  setMaintFilter,
  setSearch,
  setSelectedRowId,
  setServiceFilter,
  sortedForklifts,
  totalActiveLiftCount,
  unitLabel,
  upcomingLabelEnd,
  refreshForklifts,
  useDashboardPageShell = false,
}) {
  const headerActions = ({ activeCustomerName, logout, navigate: guardedNavigate, session }) => (
    <CustomerDashboardHeader
      accountMenuOpen={accountMenuOpen}
      accountTriggerLabel={accountTriggerLabel}
      customerName={activeCustomerName || accountLabel}
      logout={logout}
      navigate={guardedNavigate}
      onAccountMenuOpenChange={setAccountMenuOpen}
      session={session}
    />
  );

  const content = (
    <>
      <CustomerPaymentBanner alertConfig={alertConfig} />

      <DashboardPanel className="customer-preview-dashboard-panel">
        <div className="customer-preview-section-heading">
          <div>
            <Title level={3}>Fleet Status</Title>
            <Text type="secondary" className="customer-preview-helper-text">
              Use the status summaries to filter the forklift table below.
            </Text>
          </div>
          <Button onClick={clearFilters}>Clear filters</Button>
        </div>

        <FleetStatusPanel
          maintSummary={maintSummary}
          serviceSummary={serviceSummary}
          maintFilter={maintFilter}
          serviceFilter={serviceFilter}
          setMaintFilter={setMaintFilter}
          setServiceFilter={setServiceFilter}
          dueSoonWindow={dueSoonWindow}
          upcomingLabelEnd={upcomingLabelEnd}
          unitLabel={unitLabel}
        />

        <FleetStatusFilterGrid
          maintenanceFilters={mobileMaintenanceStatusFilters}
          healthFilters={mobileHealthStatusFilters}
        />

        <div className="customer-preview-table-area">
          <ForkliftListControls
            loading={loading}
            onRefresh={refreshForklifts}
            search={search}
            setSearch={setSearch}
            shownCount={sortedForklifts.length}
            totalActiveLiftCount={totalActiveLiftCount}
          />

          <ForkliftDesktopTable
            forklifts={sortedForklifts}
            loading={loading}
            navigate={navigate}
            selectedRowId={selectedRowId}
            setSelectedRowId={setSelectedRowId}
          />

          <ForkliftMobileCardList
            forklifts={sortedForklifts}
            loading={loading}
            navigate={navigate}
            selectedRowId={selectedRowId}
            setSelectedRowId={setSelectedRowId}
          />
        </div>
      </DashboardPanel>
    </>
  );

  if (useDashboardPageShell) {
    return (
      <DashboardPageShell
        title={accountLabel}
        renderHeaderActions={headerActions}
        headerClassName="customer-preview-header"
        contentClassName="customer-preview-page"
      >
        {content}
      </DashboardPageShell>
    );
  }

  return (
    <AppLayout
      title={accountLabel}
      frameless
      renderHeaderActions={headerActions}
      headerClassName="customer-preview-header"
      contentClassName="customer-preview-page"
    >
      <div className="customer-preview-shell">{content}</div>
    </AppLayout>
  );
}
